import React, { useState, useEffect } from "react";
import moment from "moment";
import packageJson from "../package.json";

const buildDateGreaterThan = (latestDate, currentDate) => {
  const momLatestDateTime = moment(latestDate);
  const momCurrentDateTime = moment(currentDate);

  if (momLatestDateTime.isAfter(momCurrentDateTime)) {
    return true;
  }
  return false;
};

function withClearCache(Component) {
  function ClearCacheComponent(props) {
    const [isLatestBuildDate, setIsLatestBuildDate] = useState(false);

    const refreshCacheAndReload = () => {
      if (caches) {
        console.log('refreshCacheAndReload');
        // Service worker cache should be cleared with caches.delete()
        caches.keys()
          .then((names) => {
            // eslint-disable-next-line no-restricted-syntax
            for (const name of names) {
              console.log(`deleting: ${name}`);
              caches.delete(name);
            }
          });
      }
      console.log('hard reload');
      // delete browser cache and hard reload
      window.location.reload(true);
    };

    useEffect(() => {
      fetch("/meta.json")
        .then((response) => response.json())
        .then((meta) => {
          const latestVersionDate = meta.buildDate;
          const currentVersionDate = packageJson.buildDate;

          console.log(`Current version is ${moment(latestVersionDate).format('LLLL')}`);
          console.log(`Latest version is ${moment(currentVersionDate).format('LLLL')}`);

          const shouldForceRefresh = buildDateGreaterThan(
            latestVersionDate,
            currentVersionDate,
          );
          if (shouldForceRefresh) {
            setIsLatestBuildDate(false);
            refreshCacheAndReload();
          } else {
            setIsLatestBuildDate(true);
          }
        });
    }, []);

    return (
      <>
        {isLatestBuildDate ? <Component {...props} /> : null}
      </>
    );
  }

  return ClearCacheComponent;
}

export default withClearCache;
